import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import MainStore from '../../../MainStore';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import AddIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/DeleteForeverOutlined';
import UserSelect from '../Users/UserSelect';

export default class AccessUserList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rights: [],
            user: {}
        };
        this.loadRights = this.loadRights.bind(this);
        this.grantRight = this.grantRight.bind(this);
        this.revokeRight = this.revokeRight.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.loadRights();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.serverId !== this.props.serverId) {
            this.loadRights();
        }
    }

    loadRights() {
        if (!this.props.serverId) return;
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/GetServerRights?serverId=' + this.props.serverId,
            null
            ,
            'application/json',
            (result) => {
                scope.setState({ rights: result });
                MainStore.setMaskUnvisible();
            },
            'GET'
        );
    }

    handleChange(user) {
        this.setState({user: user});
    }

    grantRight() {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/GrantUserRightOnServer',
            JSON.stringify({ serverId: scope.props.serverId, userId: this.state.user.id})
            ,
            'application/json',
            (result) => {
                let rights = scope.state.rights.slice(0);
                rights.push({ userId: scope.state.user.id, name: scope.state.user.name });
                scope.setState({ rights: rights, user: {} });
                MainStore.setMaskUnvisible();
            },
            'POST'
        );
    }

    revokeRight(userId) {
        var scope = this;
        MainStore.setMaskVisible();
        fetchWithAuth(
            'api/Server/RevokeUserRightOnServer',
            JSON.stringify({ serverId: this.props.serverId, userId: userId })
            ,
            'application/json',
            (result) => {
                let rights = scope.state.rights.slice(0);
                var index = rights.findIndex(r => r.userId === userId);
                if (index > -1) {
                    rights.splice(index, 1)
                }
                scope.setState({ rights: rights });
                MainStore.setMaskUnvisible();
            },
            'POST'
        );
    }

    render() {
        return (
            <div>
                <UserSelect name="" label="Пользователь" handleSelect={this.handleChange} />
                <IconButton onClick={this.grantRight} size="large"><AddIcon style={{ fill: "red" }} /></IconButton>
                {this.state.rights.map(right => <div>{right.name}<IconButton onClick={() => this.revokeRight(right.userId)} size="large"><DeleteIcon style={{ fill: "red" }} /></IconButton></div>)}
            </div>
        );
    }
}